import { render } from "./TipLayout.vue?vue&type=template&id=91b5163a&scoped=true"
import script from "./TipLayout.vue?vue&type=script&lang=js"
export * from "./TipLayout.vue?vue&type=script&lang=js"

import "./TipLayout.vue?vue&type=style&index=0&id=91b5163a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91b5163a"]])

export default __exports__